// Training videos — the staff page (mig 291). Universal: every logged-in role.
//
// Every ACTIVE video for the viewer's company, grouped by category, department shown as a label
// (ruled 2026-09-17 — logins are not linked to employees, so the ERP cannot tell a user's
// department). Opening a video records a click; it is not a training record — attendance at an HR
// session is.
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { HRC, Card, Modal, Loading, Empty } from './hr/hrkit';
import { CATEGORIES, categoryLabel, thumbUrl, Departments, Player } from './hr/trainingKit';

const VideoCard = ({ item, onOpen }) => (
  <button onClick={() => onOpen(item)} style={{ textAlign: 'left', border: `1px solid ${HRC.border}`, background: '#fff',
    borderRadius: 10, padding: 0, cursor: 'pointer', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
    <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%', background: '#eee' }}>
      <img src={thumbUrl(item.youtube_id)} alt="" loading="lazy"
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
      <span style={{ position: 'absolute', right: 8, bottom: 8, background: 'rgba(0,0,0,0.7)', color: '#fff',
        borderRadius: 6, padding: '2px 8px', fontSize: 12 }}>▶ Play</span>
    </div>
    <div style={{ padding: '10px 12px' }}>
      <div style={{ fontWeight: 700, fontSize: 14, color: HRC.text, marginBottom: 4 }}>{item.title}</div>
      {item.description && <div style={{ fontSize: 12, color: HRC.muted, marginBottom: 6 }}>{item.description}</div>}
      <Departments item={item} />
    </div>
  </button>
);

export default function Training() {
  const [items, setItems] = useState(null);
  const [company, setCompany] = useState('');
  const [err, setErr] = useState('');
  const [playing, setPlaying] = useState(null);

  useEffect(() => {
    api.get('/hr/training/library')
      .then(r => { setItems(r.data.data || []); setCompany(r.data.company_name || ''); })
      .catch(e => { setErr(e.response?.data?.error || 'Could not load training videos'); setItems([]); });
  }, []);

  const open = (item) => {
    setPlaying(item);
    // A click, recorded as one. Never blocks playback.
    // write-error-ok: a play-click counter; a failed count must never interrupt the video
    api.post(`/hr/training/items/${item.id}/open`).catch(() => {});
  };

  const groups = CATEGORIES.map(([k]) => [k, (items || []).filter(i => i.category === k)]).filter(([, list]) => list.length);

  return (
    <div style={{ padding: 24, background: HRC.pageBg, minHeight: '100%' }}>
      <h2 style={{ margin: '0 0 4px', color: HRC.sidebar, fontSize: 22 }}>Training Videos</h2>
      <div style={{ color: HRC.muted, fontSize: 13, marginBottom: 18 }}>{company ? `${company} — ` : ''}videos from the company training channel.</div>
      {err && <Card style={{ color: HRC.red, marginBottom: 12 }}>{err}</Card>}
      {items === null ? <Loading /> : !groups.length ? <Empty>No training videos yet.</Empty> : groups.map(([k, list]) => (
        <div key={k} style={{ marginBottom: 22 }}>
          <h3 style={{ margin: '0 0 10px', fontSize: 15, color: HRC.text }}>{categoryLabel(k)}</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 14 }}>
            {list.map(it => <VideoCard key={it.id} item={it} onOpen={open} />)}
          </div>
        </div>
      ))}
      {playing && (
        <Modal title={playing.title} onClose={() => setPlaying(null)} width={860}>
          <Player youtubeId={playing.youtube_id} title={playing.title} />
          <div style={{ marginTop: 8 }}><Departments item={playing} /></div>
        </Modal>
      )}
    </div>
  );
}
